import { ProjectType } from "@/consts/Project";

export enum ReagentOwnType {
  IN_HOUSE = "IN_HOUSE", // 자사제품
  COMPETITOR = "COMPETITOR", // 타사제품
  ALTERNATIVE = "ALTERNATIVE", // 대체제품
}

export enum CommodityMatchResult {
  MATCHED = "MATCHED", // 일치
  UNMATCHED = "UNMATCHED", // 불일치
  RELATED = "RELATED", // 관련
}

export enum SpecType {
  REAGENT = "reagent", // 시약
  COMMODITY = "commodity", // 장비
  NONE = "none", // 없음
}

export interface CommoditySelectionInfo {
  commodity_id: string;
  selected_company_commodity_id?: string;
}

// 공시 규격과 매칭 결과 맵
export interface CommoditySpecification {
  project_specification: string;
  company_specification?: string;
  match_result: CommodityMatchResult;
  match_reason?: string;
}

// 구성명과 구성 목록 맵
export interface ConfigurationMap {
  configuration: string;
  specification_map: CommoditySpecification;
  total_spec_count: number;
  matched_spec_count: number;
}

export interface CompanyCommodityInfo {
  commodity_id: string;
  commodity_name: string;
  sku_number?: string;
  division?: string;
  unit_price?: number;
  list_price?: string;
  configuration_map: ConfigurationMap;
  total_spec_count: number;
  matched_spec_count: number;
}

// 회사 장비 ID 와 장비 정보 맵
export interface CompanyCommodityMap {
  [key: string]: CompanyCommodityInfo;
}

// 공시 장비 규격
export interface CommoditySpecInfo {
  commodity_id: string;
  commodity_name: string;
  seq_no: number;
  quantity: number;
  unit: string;
  company_commodity_map: CompanyCommodityMap;
  selected_company_commodity_id?: string;
}

export interface AltReagentProduct {
  alt_map_id: string;
  selected: boolean;
}

export interface ReagentSpecUpdate {
  spec_id: string;
  alt_items: AltReagentProduct[];
}

export interface ReagentItemInfo {
  item_no: string;
  item_name: string;
  spec: string;
  list_price: number | string;
}

export interface ReagentAlternativeProduct {
  alt_map_id: string;
  item: ReagentItemInfo;
  selected: boolean;
}

export interface ReagentSpecInfo {
  spec_id: string;
  seq_no: number;
  item: ReagentItemInfo;
  manufacturer: string;
  quantity: number;
  unit: string;
  own_type: ReagentOwnType;
  alt_items: ReagentAlternativeProduct[];
}

// 프로젝트 시약/장비 규격 조회(대체 품목 포함)
export interface SpecReadTypeRequest {
  project_type: ProjectType;
  project_id: string;
}

export interface SpecReadTypeResponse {
  spec_type: SpecType;
}

// 프로젝트 시약 규격 조회 (대체 품목 포함)
export interface SpecReadReagentsResponse {
  budget_amount: number;
  basis_amount: number;
  basis_amount_open_date: number;
  reagents: ReagentSpecInfo[];
}

// 프로젝트 시약 규격 수정 (대체 품목 변경)
export interface SpecUpdateReagentsRequest {
  reagents: ReagentSpecUpdate[];
}

export interface SpecUpdateReagentsResponse {
  updated_at: number;
}

// 프로젝트 장비 규격 조회(대체 품목 포함)
export interface ReadSpecAnalysisCommoditiesRequest {
  project_type: ProjectType;
  project_id: string;
}

export interface ReadSpecAnalysisCommoditiesResponse {
  budget_amount: number;
  basis_amount: number;
  basis_amount_open_date: number;
  commodities: CommoditySpecInfo[];
}

// 프로젝트 장비 규격 수정(대체 품목 변경)
export interface UpdateSpecAnalysisCommoditiesRequest {
  project_type: ProjectType;
  project_id: string;
  commodity_selections: CommoditySelectionInfo[];
}

export interface UpdateSpecAnalysisCommoditiesResponse {
  updated_at: number;
}
